var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networks-tree-check"},[_c('nice-tree-check',{ref:"tree",attrs:{"tree":_vm.initTree,"hideSubtrees":false},on:{"ready":_vm.selectFakeValueParentIfNeeded,"input:lastValue":_vm.updateSelectedPlatforms},model:{value:(_vm.localPlatforms),callback:function ($$v) {_vm.localPlatforms=$$v},expression:"localPlatforms"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }